import React from 'react';
import 'App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import Categories from './pages/Categories';
import Attributes from './pages/Attributes';
import ProductManager from './pages/ProductManager';
import ShowroomCategories from './pages/ShowroomCategories';
import DealerStore from './pages/DealerStore';
import EditDealerStore from './pages/EditDealerStore';
import BlogList from './pages/BlogList';
import AddBlog from './pages/AddBlog';
import ModifyBlogContent from './pages/ModifyBlogContent';
import EventList from './pages/EventList';
import AddEvent from './pages/AddEvent';
import EditEvent from './pages/EditEvent';
import PageList from './pages/PageList';
import EditHome from './pages/EditHome';
import EditAbout from './pages/EditAbout';
import EditFaq from './pages/EditFaq';
import EditPrivacy from './pages/EditPrivacy';
import EditTerms from './pages/EditTerms';
import EditTraining from './pages/EditTraining';
import EditPartner from './pages/EditPartner';
import EditStoreLocator from './pages/EditStoreLocator';
import WidgetManager from './pages/WidgetManager';
import ModifyPageContent from './pages/ModifyPageContent';
import AddTestimonial from './pages/AddTestimonial';
import TestimonialList from './pages/TestimonialList';
import PrivateRouter from './routers/PrivateRouter';

import FileSizeLimitModal from './common/FileSizeLimitModal';

function App() {
  return (
    <Router>
      <FileSizeLimitModal />
      <Routes>
        <Route path="/signin" element={<Login />} />
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/attributes" element={<Attributes />} />
          <Route path="/products" element={<ProductManager />} />
          <Route path="/showroom-categories" element={<ShowroomCategories />} />
          <Route path="/dealer-store" element={<DealerStore />} />
          <Route path="/edit-dealer-store/:id" element={<EditDealerStore />} />
          <Route path="/blog-list" element={<BlogList />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/edit-blog/:id" element={<AddBlog />} />
          <Route path="/modify-blog-content/:id" element={<ModifyBlogContent />} />
          <Route path="/event-list" element={<EventList />} />
          <Route path="/add-event" element={<AddEvent />} />
          <Route path="/edit-event/:id" element={<EditEvent />} />
          <Route path="/page-list" element={<PageList />} />
          <Route path="/edit-home/:id" element={<EditHome />} />
          <Route path="/edit-page/1" element={<EditHome />} />
          <Route path="/edit-about/:id" element={<EditAbout />} />
          <Route path="/edit-page/2" element={<EditAbout />} />
          <Route path="/edit-faq/:id" element={<EditFaq />} />
          <Route path="/edit-page/5" element={<EditFaq />} />
          <Route path="/edit-privacy/:id" element={<EditPrivacy />} />
          <Route path="/edit-page/9" element={<EditPrivacy />} />
          <Route path="/edit-terms/:id" element={<EditTerms />} />
          <Route path="/edit-page/10" element={<EditTerms />} />
          <Route path="/edit-training/:id" element={<EditTraining />} />
          <Route path="/edit-page/12" element={<EditTraining />} />
          <Route path="/edit-partner/:id" element={<EditPartner />} />
          <Route path="/edit-page/13" element={<EditPartner />} />
          <Route path="/edit-store-locator/:id" element={<EditStoreLocator />} />
          <Route path="/edit-page/14" element={<EditStoreLocator />} />
          <Route path="/widget-manager" element={<WidgetManager />} />
          <Route path="/modify-page-content/:id" element={<ModifyPageContent />} />
          <Route path="/add-testimonial" element={<AddTestimonial />} />
          <Route path="/edit-testimonial/:id" element={<AddTestimonial />} />
          <Route path="/testimonial-list" element={<TestimonialList />} />

          <Route path="*" element={<h1>Page Not Found</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
